/**
 * Request Price Web Component
 * Handles email capture to unlock product pricing.
 */
if (!customElements.get('request-price')) {
  class RequestPrice extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('.request-price__btn');
      this.form = this.querySelector('.request-price__form');
      this.emailInput = this.querySelector('input[type="email"]');
      this.submitBtn = this.querySelector('.request-price__submit');
      this.messageEl = this.querySelector('.request-price__message');

      // If already unlocked, reveal prices immediately
      if (localStorage.getItem('priceUnlocked')) {
        this.revealAllPrices(false);
        return;
      }

      this.btn.addEventListener('click', this.toggleForm.bind(this));
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }

    toggleForm(e) {
      e.preventDefault();
      this.form.classList.toggle('is-open');
      if (this.form.classList.contains('is-open')) {
        this.emailInput.focus();
      }
    }

    async handleSubmit(e) {
      e.preventDefault();

      const email = this.emailInput.value.trim();
      if (!email || !this.emailInput.validity.valid) {
        this.emailInput.reportValidity();
        return;
      }

      this.setLoading(true);

      try {
        // POST to Shopify contact form
        const formData = new FormData();
        formData.append('form_type', 'contact');
        formData.append('utf8', '\u2713');
        formData.append('contact[email]', email);
        formData.append('contact[tags]', 'price-request');
        formData.append('contact[body]', 'Price request from product page');

        await fetch('/contact#contact_form', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        });

        // Fire-and-forget to Mailchimp if configured
        const mailchimpUrl = this.dataset.mailchimpUrl;
        if (mailchimpUrl) {
          const mcData = new URLSearchParams();
          mcData.append('EMAIL', email);
          // Use no-cors mode for Mailchimp cross-origin
          fetch(mailchimpUrl, {
            method: 'POST',
            body: mcData,
            mode: 'no-cors'
          }).catch(() => {}); // Ignore Mailchimp errors
        }

        // Store unlock state
        localStorage.setItem('priceUnlocked', 'true');
        localStorage.setItem('priceUnlockedEmail', email);

        this.showMessage('success', 'Prices are now visible across the site.');
        this.revealAllPrices();

        // Hide the button and collapse the email form, message stays visible
        this.btn.hidden = true;
        this.form.classList.remove('is-open');

      } catch (err) {
        this.showMessage('error', 'Something went wrong. Please try again.');
      } finally {
        this.setLoading(false);
      }
    }

    setLoading(loading) {
      if (loading) {
        this.submitBtn.disabled = true;
        this.submitBtn.dataset.originalText = this.submitBtn.textContent;
        this.submitBtn.innerHTML = '<span class="request-price__spinner"></span>Sending...';
      } else {
        this.submitBtn.disabled = false;
        this.submitBtn.textContent = this.submitBtn.dataset.originalText || 'Submit';
      }
    }

    showMessage(type, text) {
      this.messageEl.className = 'request-price__message request-price__message--' + type;
      this.messageEl.textContent = text;
      this.messageEl.hidden = false;
    }

    revealAllPrices() {
      // Single class toggle drives all visibility via CSS
      document.documentElement.classList.add('price-unlocked');

      // Dispatch custom event
      document.dispatchEvent(new CustomEvent('on:price:reveal'));
    }
  }

  customElements.define('request-price', RequestPrice);
}
